import { inject, Injectable } from '@angular/core';
import { NotificationSlugEnum } from '@app/generated/graphql';
import { captureException } from '@sentry/angular';
import { NotificationPreferencesConfigService } from '../notification-preferences/services/notification-preferences-config.service';
import { INotificationMessageConfig } from '../notification-preferences/interfaces/interface';

@Injectable({ providedIn: 'root' })
export class NotificationActionService {
  // dependencies
  private _notificationPreferencesConfigService = inject(
    NotificationPreferencesConfigService,
  );

  // execute the action associated with the notification rule slug
  public executeAction(
    metadata: Record<string, unknown>,
    notificationRuleSlug: NotificationSlugEnum,
  ): void {
    const entry: INotificationMessageConfig | undefined =
      this._notificationPreferencesConfigService.getNotificationMessageConfig(
        notificationRuleSlug,
      );

    if (!entry?.action) {
      return;
    }
    try {
      entry.action(metadata);
    } catch (error) {
      console.error('Error executing action', error);
      captureException(error);
    }
  }
}
